<template>
    <el-dialog
            class="codeDialog"
            title="二维码示例"
            :visible="true"
            width="40%"
            :before-close="handleClose">
        <div class="box">
            <img src="./codepic.png" alt="">
            <div>
                <p>二维码格式:产品编号,数量,生产批次号,生产日期,有效期至,产品条码</p>
                <p style="color: blue">如：产品编号,10,20190317,2019-03-17,2022-03-17,123456789</p>
                <p style="color:red">输入的数据中间隔符为英文逗号,但是数据不能存在英文逗号,即",",</p>
                <p style="color:red">如条码不能是12131,2313,,或者日期为2015,01,01</p>
            </div>
        </div>

         <span slot="footer" class="dialog-footer">
   <el-button @click="handleClose">取 消</el-button>
   <el-button type="primary" @click="handleClose">确 定</el-button>
 </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "code-dialog",
        data() {
            return {}
        },
        methods:
            {
                handleClose(){
                    this.$emit('handleClose');
                }
            },
        created() {
        },
    }
</script>

<style lang="scss" scoped>
    .box{
        width: 100%;
        height: 150px;
        img{
            width: 150px;
            height: 150px;
            display: block;
            float: left;
        }
        div{
            float: left;
            margin-left: 20px;
            p{
                line-height: 30px;
            }
        }

    }

</style>